import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, Image as ImageIcon } from "lucide-react";
import api, { API } from "../lib/api";
import { loadBranding } from "../lib/branding";
import { PageHeader } from "../components/common/PageHeader";
import { Button } from "../components/ui/button";

const SLOTS = [
  { kind: "product", label: "MeterFlow Product Logo", hint: "Main product branding · PNG/SVG · ~160×40 · max 2 MB" },
  { kind: "company", label: "Company Logo", hint: "Secondary company identity · PNG/SVG · max 2 MB" },
  { kind: "login", label: "Login Logo", hint: "Optional login-screen logo · PNG/SVG · max 2 MB" },
  { kind: "favicon", label: "Favicon / App Icon", hint: "Browser tab icon · PNG/ICO · 32×32 or 64×64 · max 2 MB" },
];

function Slot({ slot, url, onUploaded }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/branding/${slot.kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${slot.label} updated`);
      onUploaded();
    } catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={`branding-slot-${slot.kind}`} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-1 text-sm font-semibold text-slate-800">{slot.label}</div>
      <div className="mb-3 text-xs text-slate-400">{slot.hint}</div>
      <div className="flex items-center gap-4">
        <div className="grid h-16 w-28 place-items-center overflow-hidden rounded-md border border-slate-200 bg-slate-50">
          {url ? <img src={`${API}${url}`} alt={slot.label} className="max-h-14 max-w-24 object-contain" /> : <ImageIcon className="h-6 w-6 text-slate-300" />}
        </div>
        <div>
          <input ref={ref} type="file" accept="image/png,image/jpeg,image/svg+xml,image/webp,image/x-icon" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`branding-input-${slot.kind}`} />
          <Button size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid={`branding-upload-${slot.kind}`}>
            <UploadCloud className="mr-1 h-4 w-4" /> {busy ? "Uploading…" : url ? "Replace" : "Upload"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default function Branding() {
  const [b, setB] = useState({});
  const refresh = () => loadBranding(true).then(setB);
  useEffect(() => { refresh(); }, []);
  return (
    <div>
      <PageHeader title="Branding" subtitle="Upload company & product logos and favicon. If none is set, the MeterFlow “MF” mark is used." />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {SLOTS.map((s) => <Slot key={s.kind} slot={s} url={b[s.kind]} onUploaded={refresh} />)}
      </div>
    </div>
  );
}
